export default {
  PROJECT_NOT_INCLUDED:
    'This project is not included in your subscription account.',
  REQUEST_ACCESS: 'Request Access',
}
